import { addYears } from "date-fns";
import { t } from "ttag";

import { SessionFrequencyField } from "@/features/coaching/components";
import { useCreateSessionContext } from "@/features/coaching/context";
import { SESSION_FREQUENCY } from "@/features/coaching/models";
import { SessionFields } from "@/features/coaching/sections/session-fields";
import { NOW } from "@/shared/models/legacy-constants";
import { Card, DatePicker, Form } from "@/shared/ui";

export const CreateSessionForm = () => {
  const { sessionForm } = useCreateSessionContext();

  const frequency = sessionForm.watch("frequency");

  return (
    <Card.Root className="p-6">
      <Card.Title>{t`Main info`} </Card.Title>
      <Card.Content className="grid gap-x-4 gap-y-0.5 md:grid-cols-2">
        <SessionFields form={sessionForm}>
          <SessionFrequencyField
            control={sessionForm.control}
            onValueChange={(value) => {
              if (value === SESSION_FREQUENCY.ONE_TIME) {
                sessionForm.setValue("endAt", undefined);
              }
            }}
          />

          <Form.Field
            control={sessionForm.control}
            name="endAt"
            disabled={frequency === SESSION_FREQUENCY.ONE_TIME}
            render={({ field: { ref: _, ...field } }) => (
              <Form.Item>
                <Form.Label
                  aria-required={frequency !== SESSION_FREQUENCY.ONE_TIME}
                >
                  {t`End date`}
                </Form.Label>
                <Form.Control>
                  <DatePicker
                    {...field}
                    startMonth={NOW}
                    endMonth={addYears(NOW, 1)}
                    disabledDays={{ before: sessionForm.watch("startAt") }}
                    placeholder={t`Select an end date`}
                  />
                </Form.Control>
                <Form.Message compact={false} />
              </Form.Item>
            )}
          />
        </SessionFields>
      </Card.Content>
    </Card.Root>
  );
};
